import { FaArrowLeft } from 'react-icons/fa';
import { useEffect, type ReactNode } from 'react';

interface ModalProps {
  isOpen: boolean;
  title: ReactNode;
  onClose: () => void;
  children: ReactNode;
  transparent?: boolean;
}

export const Modal = ({ isOpen, title, onClose, children, transparent }: ModalProps) => {
  const closeModal = () => {
    onClose();
  };

  useEffect(() => {
    // Add the no-scroll class to the body when the modal opens
    if (isOpen) {
      document.body.classList.add('no-scroll');
    } else {
      document.body.classList.remove('no-scroll');
    }

    // Clean up by removing the class when the component unmounts or when isOpen changes
    return () => {
      document.body.classList.remove('no-scroll');
    };
  }, [isOpen]);

  return (
    <>
      {isOpen && (
        <div className="fixed inset-0 z-[1000] flex items-center justify-center overflow-x-hidden outline-none">
          <div className="modal-overlay fixed inset-0 z-[1000]"></div>
          <div
            className={`flex relative z-[1001] p-0 mx-auto ${transparent ? 'bg-transparent' : 'bg-transparent'} rounded-lg`}
          >
            <div
              role="header"
              className="modal-header fixed top-0 left-0 right-0 z-[1002]"
            >
              <div className="modal-header-inner flex justify-between items-center px-4 py-2">
                <FaArrowLeft
                  onClick={closeModal}
                  className="modal-header-back interactive-cursor"
                />
                {title}
                <button
                  onClick={closeModal}
                  className="modal-header-close interactive-cursor"
                  aria-label="Close preview"
                >
                  <svg
                    className="w-6 h-6 interactive-cursor"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>
            </div>

            <div className="mt-8 text-center z-[1001] modal-body-transparent">{children}</div>
          </div>
        </div>
      )}
    </>
  );
};
